import { sha256Base64Url } from '../crypto/hash';
import { normalizeOriginPathUrl } from '../url/normalize';

export const AUTO_FORM_ACTION_KEY_PREFIX = 'f1u_';
export const AUTO_FORM_KEY_HASH_LENGTH = 43;

export function normalizeFormActionUrl(
  action: string | null | undefined,
  options: { pageHref?: string } = {},
): string | null {
  const normalizedAction = action?.trim();
  if (!normalizedAction) return null;
  return normalizeOriginPathUrl(normalizedAction, options);
}

async function createPrefixedHash(prefix: string, material: string): Promise<string> {
  const hash = await sha256Base64Url(material);
  return `${prefix}${hash.slice(0, AUTO_FORM_KEY_HASH_LENGTH)}`;
}

export async function createAutoFormKey(
  action: string | null | undefined,
  options: { pageHref?: string } = {},
): Promise<string | null> {
  const normalizedAction = normalizeFormActionUrl(action, options);
  if (!normalizedAction) return null;

  return createPrefixedHash(AUTO_FORM_ACTION_KEY_PREFIX, normalizedAction);
}
